<template>
    <div>
        <base-crud crudName="Clientes" newText="Novo Cliente" :table="domainTable" :columns="columns" :options="options"
            :endPoint='endPoint' :enableAdd="true" :enableEdit="true" :enableDelete="false" :enableView="true"
            :extra="extra" @deleteDomain="deleteDomain">
        </base-crud>
    </div>
</template>

<script>
import BaseCrud from '../Base/BaseCrud'

export default {
    data: function () {
        return {
            domainTable: 'domainTable',
            teams: [],
            pages: [],
            url: '',
            columns: ['id', 'domain', 'tenant_id', 'company_name', 'actions'],
            tableData: ['id', 'domain', 'tenant_id', 'company_name'],
            options: {
                filterable: ['id', 'domain', 'tenant_id'],
                filterByColumn: true,
                sortable: ['id', 'domain', 'tenant_id'],
                pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    'id': 'ID',
                    'domain': 'Domínio',
                    'tenant_id': 'Tenant',
                    'company_name': 'Nome',
                    'actions': 'Ações'
                },
                templates: {
                    company_name: function (h, row, index) {
                        return row.tenant ? row.tenant.company_name : '';
                    },
                },
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = ["tenant"];

                    return this.$http
                        .get(this.url + '?' + query, requestData)
                        .catch(
                            function (e) {
                                this.dispatch("error", e);
                            }.bind(this)
                        );
                },
            },
            extra: [
                {
                    id: 1,
                    label: "",
                    class: "btn btn-danger fa fa-trash",
                    style: "",
                    title: "Deletar Domínio",
                    name: "deleteDomain",
                    icon: "",
                    action: (row) => this.deleteDomain(row.id)
                },
            ],
            endPoint: 'domains/'
        }
    },
    methods: {
        query: function (query) {
            let columns = {
                id: 'id',
                tenant_id: 'tenant_id',
                domain: 'domain',
            };
            let filters = "";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });

            return filters;
        },
        deleteDomain(domainId) {

            let self = this;

            swal({
                title: 'Tem certeza?',
                text: 'Digite "DELETAR" para confirmar a exclusão do domínio.',
                content: {
                    element: 'input',
                    attributes: {
                        placeholder: 'Digite "DELETAR"',
                        type: 'text',
                    },
                },
                buttons: {
                    cancel: 'Cancelar',
                    confirm: {
                        text: 'Excluir',
                        closeModal: false,
                    },
                },
                dangerMode: true,
            }).then((inputValue) => {
                if (inputValue === null) {
                    // Usuário clicou em "Cancelar"
                    return;
                }

            
                if (inputValue !== 'DELETAR') {
                    swal('Erro!', 'Você deve digitar "DELETAR" para confirmar.', 'error');
                    return;
                }

                this.$http
                    .delete(`${self.$store.getters.api + 'domains/'}${domainId.row.id}`)
                    .then(response => {
                        swal('Excluído!', 'O domínio foi deletado com sucesso.', 'success');
                        location.reload();
                        
                    });
            });
        }
    },
    components: {
        BaseCrud
    }
}
</script>

<style scoped>
.VuePagination {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Domains/Crud.vue